import { Breakpoints } from '@cabonline/ui-shared';
import { useState, useEffect } from 'react';

export type DeviceType = 'mobile' | 'tablet' | 'desktop';

export const useDeviceType = (): DeviceType => {
  const getDeviceType = (windowWidth: number): DeviceType => {
    if (windowWidth < Breakpoints.Mobile) {
      return 'mobile';
    } else if (
      windowWidth >= Breakpoints.Mobile &&
      windowWidth < Breakpoints.Tablet
    ) {
      return 'tablet';
    } else {
      return 'desktop';
    }
  };

  const [deviceType, setDeviceType] = useState<DeviceType>(
    getDeviceType(window.innerWidth)
  );

  useEffect(() => {
    const handleResize = () => {
      setDeviceType(getDeviceType(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return deviceType;
};
